import { useEffect, useRef, useState } from "react";

const API_BASE_URL = "https://bluewaterdubai.websiteseoonline.com";

function buildApiUrl(pathname) {
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || API_BASE_URL).replace(/\/$/, "");
  return `${baseUrl}${pathname}`;
}

function CityDropdown({ value, onChange }) {
  const [inputValue, setInputValue] = useState(value?.label || "");
  const [options, setOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (value?.label) {
      setInputValue(value.label);
    }
  }, [value]);

  useEffect(() => {
    function handleDocumentClick(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleDocumentClick);
    return () => document.removeEventListener("mousedown", handleDocumentClick);
  }, []);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const controller = new AbortController();
    const timer = window.setTimeout(async () => {
      setIsLoading(true);

      try {
        const response = await fetch(buildApiUrl(`/api/GetCities.ashx?search=${encodeURIComponent(inputValue)}`), {
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("Unable to load locations");
        }

        const data = await response.json();
        setOptions(Array.isArray(data) ? data : []);
      } catch (err) {
        if (err.name !== "AbortError") {
          setOptions([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    }, 300);

    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [inputValue, isOpen]);

  function handleInputChange(event) {
    setInputValue(event.target.value);
    setIsOpen(true);

    if (value) {
      onChange(null);
    }
  }

  function handleSelect(option) {
    onChange(option);
    setInputValue(option.label);
    setIsOpen(false);
  }

  function handleClear() {
    onChange(null);
    setInputValue("");
    setIsOpen(true);
  }

  return (
    <div className="city-dropdown" ref={wrapperRef}>
      <div className="city-dropdown-control">
        <input
          id="location"
          name="location_search"
          type="text"
          autoComplete="off"
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setIsOpen(true)}
          placeholder="Community / Sub-Community"
        />
        {value && (
          <button type="button" className="city-dropdown-clear" onClick={handleClear} aria-label="Clear location">
            Clear
          </button>
        )}
      </div>
      <input type="hidden" name="location" value={value?.value || ""} />
      {isOpen && (
        <div className="city-dropdown-menu">
          {isLoading && <div className="city-dropdown-option city-dropdown-option--muted">Loading locations...</div>}
          {!isLoading &&
            options.map((option) => (
              <button type="button" className="city-dropdown-option" key={option.value || option.label} onMouseDown={(event) => event.preventDefault()} onClick={() => handleSelect(option)}>
                {option.label}
              </button>
            ))}
          {!isLoading && options.length === 0 && <div className="city-dropdown-option city-dropdown-option--muted">No locations found</div>}
        </div>
      )}
    </div>
  );
}

export default CityDropdown;
